import userService from './user.service';

const user = {
	namespaced: true,
	state: {
		users: [],
		userDetails: undefined,
		isSearchingUsers: false,
		setIsSavingUser: false,
	},
	actions: {
		async getAllUsers({ commit, dispatch }) {
			commit('setIsSearchingUsers', true);
			try {
				const result = await userService.getAllUsers();
				commit('setUsers', result.data);
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
			commit('setIsSearchingUsers', false);
		},
		async getUserById({ commit, dispatch }, id) {
			commit('setIsSearchingUsers', true);
			try {
				const result = await userService.getUserById(id);
				commit('setUserDetails', result.data);
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e.response.data,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
			commit('setIsSearchingUsers', false);
		},
		async updateUser({ dispatch, commit }, userDetail) {
			commit('setIsSavingUser', true);
			try {
				await userService.updateUser(userDetail);
				dispatch('getAllUsers');
				dispatch('toast/makeToast', { message: 'admin.item-updated' }, { root: true });
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e.response.data,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
			commit('setIsSavingUser', false);
		},
		async delete({ dispatch }, userDetail) {
			try {
				await userService.delete(userDetail);
				dispatch('getAllUsers');
				dispatch('toast/makeToast', { message: 'admin.item-removed' }, { root: true });
			} catch (e) {
				dispatch('toast/makeToast', {
					message: e.response.data,
					type: 'error',
					icon: 'warning',
				}, { root: true });
			}
		}
	},
	mutations: {
		setUsers(state, users) {
			state.users = users;
		},
		setUserDetails(state, userDetails) {
			state.userDetails = userDetails;
		},
		setIsSearchingUsers(state, searchState) {
			state.isSearchingUsers = searchState;
		},
		setIsSavingUser(state, saveState) {
			state.isSavingUser = saveState;
		},
	},
};

export default user;
